var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-form" },
    [
      _vm._t("default", null, {
        captchaModel: _vm.captchaModel,
        contactModel: _vm.contactModel,
        validationErrors: _vm.validationErrors,
        onFormSubmit: _vm.onFormSubmit,
        onRefreshCaptcha: _vm.onRefreshCaptcha,
        onInput: _vm.onInput,
        responseMessage: _vm.responseMessage,
        showFormular: _vm.showFormular,
        showValidationErrors: _vm.showValidationErrors,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }